<template>
  <div class="content fd-content">
    <!--活动渲染内容 -->
    <span class="fd-search-result">共{{conductLength}}个活动</span>

    <div v-show="numbers !=0" class="show-box">
      <ul class="show-list">
        <li class="show-list-li" v-if="conduct" v-for="(item,ind) in conduct" style="height: 178px;margin-bottom: 15px">
          <a href="javascript:void(0);" @click="detail(item)">
            <div class="show-remd-logo" >
              <img v-if="item.activity" :src="JSON.parse(item.activity.hostunit).host_avatar" alt=""/>
              <img v-if="item.hostunit && item.hostunit.host_avatar" :src="item.hostunit.host_avatar" alt=""/>
            </div>
            <div class="show-remd-tit" v-if="item.activity && item.activity.hostunit">
              {{JSON.parse(item.activity.hostunit).channel_name}}
            </div>

            <div class="show-remd-tit" v-if="item.hostunit && item.hostunit.channel_name">
              {{item.hostunit.channel_name}}
            </div>
            <div  class="show-remd-tit"  v-else></div>
            <div class="show-remd-bg">
              <div class="pic-box">
                <img v-if="item.activity && item.activity.playbill" v-lazy="JSON.parse(item.activity.playbill).playbill_small_h5 + '?p=3&o=2&w=350&h=197'" alt="">
                <img v-else v-lazy="item.playbill.playbill_small_h5 + '?p=3&o=2&w=350&h=197'">
                <em class="pic-box-em" style="top: -4px;right: -4px;" v-if="new Date(item.end_time).getTime()/1 - new Date().getTime() <= '0' || find.progress == 'off'"><img :src="globalUrl + 'static/dist/img/off.png'" alt=""/></em>
              </div>
              <p v-if="item.item_title">{{item.item_title,18|ellipsis}}</p>
              <p v-else>{{item.title,18|ellipsis}}</p>
            </div>
         <!-- </router-link>-->
          </a>
        </li>
      </ul>
      <!-- load -->
      <div class="content index-content" style="padding-top: 0" v-if="scrill">
        <div class="id-content-inner">
          <div class="loader">
            <div class="loader-inner ball-pulse" style="display: block">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
/*import infiniteScroll from 'vue-infinite-scroll'*/
export default {
  props: [
    'find'
  ],
  data (){
    return {
      conduct: [],
      conductLength: '',
      numbers: '',
      scrill: 'true',
      globalUrl : API.GlobalUrl
    }
  },
  methods: {
    //操作按钮事件
    detail(item){//跳转详情页面

      if(item.url) {
        if(item.type == 1 || item.type == 2){
          var hrefHTML = this.hrefHTML(item.type,item.id)
          if(hrefHTML){
            window.location.href = hrefHTML
          }else{
            this.$router.push({name: 'Detail', params: {id: item.id}});
          }

        }else{
          var hrefHTML = this.hrefHTML(item.url ,item.id)
          if(hrefHTML){
            window.location.href = hrefHTML
          }else {
            if (item.url == 2) {
              this.$router.push({name: 'Notice', params: {id: item.id}});
            } else if (item.url == 3) {
              this.$router.push({name: 'list_vote', params: {id: item.id, active: 1}});
            } else {
              this.$router.push({name: 'Detail', params: {id: item.id}});
            }
          }
        }
      }else if(item.url_type){
        var hrefHTML = this.hrefHTML(item.url_type ,item.id)
        if(hrefHTML){
          window.location.href = hrefHTML
        }else {
          this.$router.push({name: 'Detail', params: {id: item.id}});
        }
      }else{
        var hrefHTML = this.hrefHTML(0 ,item.id)
        if(hrefHTML){
          window.location.href = hrefHTML
        }else {
          this.$router.push({name: 'Detail', params: {id: item.id}});
        }
      }
    },

  },
  created: function () {
    var that = this;
    that.$watch(function () {
        console.log(this.find)
      if (that.find.page == 1) {
        that.conduct = []
      }
      var Activities = '';
      if(that.find.type == 'indexhotactivity'){
        Activities = API.GetHotActivity;
      }else{
        Activities = API.GetActivities;
      }
      that.$http.get(Activities, {params: that.find})
          .then(function (res) {
        //  console.log(res)
        if (res.code == '0') {
          for (var i = 0; i < res.data.length; i++) {
            that.conduct.push(res.data[i])
          }
          that.conductLength = res.total;
          that.numbers = that.conduct.length;
          if(that.numbers >= that.conductLength ||  that.conduct.length < 10 || res.data.length < 5){
            that.scrill= false
          }else{
            that.scrill= true
          }

          that.$nextTick(function () {
            //是否显示
            //微信分享
           if(res.total > 0){
                let metas = $('head').children('meta');
                var desc = metas[1].content;
                var dataName = {
                  title: document.title,  //分享标题
                  desc: that.removeTAG(desc,110),//metas[1].content,//分享简介(内容)
                  imgAddress: that.conduct[0].playbill.playbill_h5,//分享图片地址
                  Retain: '',//保留
                  url: window.location.href //点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
                };
                that.weixinShare(dataName)
            }
            //图片尺寸控制 16:9
            var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
            $('.pic-box').find('img').css({height: picHimg, visibility: 'visible'});
          }, 500)
        }
      });
    })
  },
  mounted: function () {
    //操作DOM
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/template/activity.vue